import {
  clearConnectorServiceDesc,
  getConnectorServiceDescFail,
  getConnectorServiceDescStarted,
  getConnectorServiceDescSuccess
} from '../../../reducer/connectors/ConnectorServiceDescReducer';
import { getConnectorServiceDesc } from '../../actionType/connectors/ConnectorServiceDesc';
import {
  ClearGetConnectorServiceDesc,
  GetConnectorServiceDescFailure,
  GetConnectorServiceDescFailurePayload,
  GetConnectorServiceDescRequest,
  GetConnectorServiceDescStarted,
  GetConnectorServiceDescSuccess,
  GetConnectorServiceDescSuccessPayload
} from '../../types/connectors/GetConnectorServiceTypes';
import { IConnectorServiceDescRequest } from '../../types/connectors/ConnectorServiceDescTypes';

export const getConnectorServiceDescRequest = (reqObject: IConnectorServiceDescRequest): GetConnectorServiceDescRequest => ({
  type: getConnectorServiceDesc.FETCH_CONNECTOR_SERVICE_DESC_REQUEST,
  requestObject: reqObject,
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const getConnectorServiceDescStart = (): GetConnectorServiceDescStarted => ({
  type: getConnectorServiceDescStarted.type,
});

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const getConnectorServiceDescSuccessful = (
  payload: GetConnectorServiceDescSuccessPayload
): GetConnectorServiceDescSuccess => ({
  type: getConnectorServiceDescSuccess.type,
  payload,
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getConnectorServiceDescFailure = (
  payload: GetConnectorServiceDescFailurePayload
): GetConnectorServiceDescFailure => ({
  type: getConnectorServiceDescFail.type,
  payload,
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearGetConnectorServiceDesc = (): ClearGetConnectorServiceDesc => ({
  type: clearConnectorServiceDesc.type,
});
